<template>
  <div v-if="currentUser" class="users-download-admin">
    <div class="page-header">
      <h1>Eksport użytkowników</h1>
      <button class="btn-outline" @click="resetFilters">Wyczyść filtry</button>
    </div>

    <div class="section-card position-relative">
      <div class="section-card-header">
        <HintComponent page-key="admin_panel_users_list_download" :absolute="true"/>
        <h2>Pobierz listę użytkowników (CSV)</h2>
        <p class="section-subtitle">
          Ustaw kryteria i pobierz plik CSV z dopasowanymi użytkownikami.
        </p>
      </div>

      <form class="download-form" @submit="downloadUsers">
        <div class="form-grid">
          <div class="form-group">
            <label for="stateSelect">Województwo</label>
            <select id="stateSelect" v-model="searchParams.state_id">
              <option value="">Wszystkie</option>
              <option :value="state.id" v-for="state in states" :key="state.id">
                {{ state.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="categorySelect">Kategoria</label>
            <select id="categorySelect" v-model="searchParams.category_id">
              <option value="">Wszystkie</option>
              <option :value="category.id" v-for="category in categories" :key="category.id">
                {{ category.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="subscriptionSelect">Subskrypcja</label>
            <select id="subscriptionSelect" v-model="searchParams.subscription_id">
              <option value="">Wszystkie</option>
              <option :value="sub.id" v-for="sub in subscriptions" :key="sub.id">
                {{ sub.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="city">Miasto</label>
            <input
                type="text"
                id="city"
                name="city"
                v-model="searchParams.city"
                placeholder="Np. Warszawa"
            >
          </div>
        </div>

        <div class="form-group radios-group">
          <label>Ma wysłane SMS-y</label>
          <div class="radio-options">
            <label class="radio-item" for="haveSentSms">
              <input type="radio" id="haveSentSms" :value="true" v-model="searchParams.have_sent_sms">
              <span>Tak</span>
            </label>
            <label class="radio-item" for="haventSentSms">
              <input type="radio" id="haventSentSms" :value="false" v-model="searchParams.have_sent_sms">
              <span>Nie</span>
            </label>
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn-outline" @click="resetFilters">Resetuj</button>
          <button type="submit" class="btn-green" :disabled="isDownloading">
            {{ isDownloading ? 'Pobieranie...' : 'Pobierz CSV' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'UsersDownload',
  components: {HintComponent},
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      states: [],
      categories: [],
      subscriptions: [],
      isDownloading: false,
      searchParams: {
        state_id: null,
        role_id: 2,
        have_sent_sms: true,
        sortAb: true,
        city: '',
        subscription_id: null,
        category_id: null,
      },
    };
  },
  props: ['isVisible'],
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }

    axios.get('/Categories')
        .then(res => {
          this.categories = res.data || [];
        });

    axios.get('/State')
        .then(res => {
          this.states = res.data || [];
        });

    axios.post('/SubscriptionSearch', { page: 1, limit: 100 })
        .then(res => {
          this.subscriptions = (res.data && res.data.items) ? res.data.items : [];
        })
        .catch(() => {
          this.subscriptions = [];
        });
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  methods: {
    resetFilters() {
      this.searchParams = {
        state_id: null,
        role_id: 2,
        have_sent_sms: true,
        sortAb: true,
        city: '',
        subscription_id: null,
        category_id: null,
      };
    },
    downloadUsers(e) {
      e.preventDefault();
      this.isDownloading = true;

      const config = {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Content-Disposition': 'application/json',
        },
      };

      axios.post('/UsersCSVList', this.searchParams, config)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Users_lists.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();

            this.appStore.setIsSuccess('Plik CSV został pobrany');
          })
          .catch(() => {
            this.appStore.setIsAlert('Brak użytkowników spełniających kryteria');
          })
          .finally(() => {
            this.isDownloading = false;
          });
    },
  },
};
</script>

<style scoped>
.users-download-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.download-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.form-group input,
.form-group select {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #10b981;
}

.radios-group {
  padding-top: 4px;
  border-top: 1px solid #e5e7eb;
}

.radio-options {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.radio-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 1.4rem;
  color: #1f2937;
  cursor: pointer;
}

.radio-item input[type="radio"] {
  accent-color: #10b981;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.5rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .users-download-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-green,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .form-actions {
    justify-content: stretch;
  }
}
</style>